import Image from 'next/image';
import { assertPayloadType } from '@/modules/utils/assert';
import type { BackgroundIllustration as BackgroundIllustrationType, Media } from '@/payload/types';
import styles from './BackgroundIllustration.module.scss';

type BackgroundProps = {
	background?: (number | null) | BackgroundIllustrationType;
};

export default function BackgroundIllustration({ background }: BackgroundProps) {
	if (!background) return null;

	assertPayloadType<BackgroundIllustrationType>(background);
	assertPayloadType<Media>(background.mobile);
	assertPayloadType<Media>(background.desktop);

	return (
		<figure className={styles.backgroundImage} aria-hidden="true">
			<Image
				src={background.mobile.url ?? ''}
				className={styles.mobileImage}
				width={getImageWidth(background.mobile, 599)}
				height={getImageHeight(background.mobile, 599)}
				alt=""
			/>
			<Image
				src={background.desktop.url ?? ''}
				className={styles.desktopImage}
				width={getImageWidth(background.desktop, 1108)}
				height={getImageHeight(background.desktop, 1108)}
				alt=""
			/>
			<div className={styles.gradientOverlay} />
		</figure>
	);
}

function getImageWidth(media: Media | undefined, maxWidth: number): number {
	if (!media?.width) return maxWidth;
	return Math.min(media.width, maxWidth);
}

function getImageHeight(media: Media | undefined, maxWidth: number): number {
	if (!media?.width || !media?.height) return media?.height ?? 0;
	const width = getImageWidth(media, maxWidth);
	return Math.round((width / media.width) * media.height);
}
